// extracted by mini-css-extract-plugin
module.exports = {"root":"root--dDGRN","post":"post--1gjGJ"};